'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.onConfirmReceipt = onConfirmReceipt;
exports.onCancelOrder = onCancelOrder;
exports.openDetailModal = openDetailModal;
exports.closeDetailModal = closeDetailModal;
exports.getDetail = getDetail;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by zfc on 2016/9/9.
 */
var LOAD = 'goeasy-crafts/orderDetail/LOAD';
var LOAD_SUCCESS = 'goeasy-crafts/orderDetail/LOAD_SUCCESS';
var LOAD_FAIL = 'goeasy-crafts/orderDetail/LOAD_FAIL';

var SUBMIT = 'goeasy-crafts/orderDetail/SUBMIT';
var SUBMIT_SUCCESS = 'goeasy-crafts/orderDetail/SUBMIT_SUCCESS';
var SUBMIT_FAIL = 'goeasy-crafts/orderDetail/SUBMIT_FAIL';

// CANCELORDER, CANCELORDER_SUCCESS, CANCELORDER_FAIL

var CANCELORDER = 'goeasy-crafts/orderDetail/CANCELORDER';
var CANCELORDER_SUCCESS = 'goeasy-crafts/orderDetail/CANCELORDER_SUCCESS';
var CANCELORDER_FAIL = 'goeasy-crafts/orderDetail/CANCELORDER_FAIL';

var OPENDETAILMODAL = 'goeasy-crafts/orderDetail/OPENDETAILMODAL';

var CLOSEDETAILMODAL = 'goeasy-crafts/orderDetail/CLOSEDETAILMODAL';

var GETDETAIL = 'goeasy-crafts/orderDetail/GETDETAIL';
var GETDETAIL_SUCCESS = 'goeasy-crafts/orderDetail/GETDETAIL_SUCCESS';
var GETDETAIL_FAIL = 'goeasy-crafts/orderDetail/GETDETAIL_FAIL';

var initialState = {
  detailData: {},
  loaded: false
};

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: (0, _extends3.default)({}, state.data, action.result)
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        data: null,
        error: action.error
      });
    case SUBMIT:
      return (0, _extends3.default)({}, state, {
        submitting: true
      });
    case SUBMIT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        submitting: false,
        submitted: true,
        submitData: action.result
      });
    case SUBMIT_FAIL:
      return (0, _extends3.default)({}, state, {
        submitting: false,
        submitted: false,
        submitData: null,
        error: action.error
      });
    case CANCELORDER:
      return (0, _extends3.default)({}, state, {
        canceling: true
      });
    case CANCELORDER_SUCCESS:
      return (0, _extends3.default)({}, state, {
        canceling: false,
        canceled: true,
        cancelData: action.result
      });
    case CANCELORDER_FAIL:
      return (0, _extends3.default)({}, state, {
        canceling: false,
        canceled: false,
        cancelData: null,
        error: action.error
      });

    case GETDETAIL:
      return (0, _extends3.default)({}, state, {
        detailGetting: true
      });
    case GETDETAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        detailGetting: false,
        detailGotten: true,
        detailData: action.result
      });
    case GETDETAIL_FAIL:
      return (0, _extends3.default)({}, state, {
        detailGetting: false,
        detailGotten: false,
        detailData: {},
        error: action.error
      });
    case OPENDETAILMODAL:
      return (0, _extends3.default)({}, state, {
        detailModalOpened: true,
        modalProductId: action.productId
      });
    case CLOSEDETAILMODAL:
      return (0, _extends3.default)({}, state, {
        detailModalOpened: false,
        modalProductId: '',
        detailData: {}
      });
    default:
      return state;
  }
}

function isLoaded(globalState) {
  return globalState.orderDetail && globalState.orderDetail.loaded;
}

function load(orderId, page, loadedPages) {
  // console.log(orderId);
  // console.log(page);
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post('/orderDetail', {
        data: {
          type: 'getData',
          orderId: orderId,
          page: page,
          loadedPages: loadedPages
        }
      });
    }
  };
}

function onConfirmReceipt(orderId) {
  return {
    types: [SUBMIT, SUBMIT_SUCCESS, SUBMIT_FAIL],
    promise: function promise(client) {
      return client.post('/orderDetail', {
        data: {
          type: 'submit',
          orderId: orderId
        }
      });
    }
  };
}

function onCancelOrder(orderId) {
  return {
    types: [CANCELORDER, CANCELORDER_SUCCESS, CANCELORDER_FAIL],
    promise: function promise(client) {
      return client.post('/orderDetail', {
        data: {
          type: 'cancelOrder',
          orderId: orderId
        }
      });
    }
  };
}

function openDetailModal(productId) {
  return {
    type: OPENDETAILMODAL,
    productId: productId
  };
}

function closeDetailModal() {
  return {
    type: CLOSEDETAILMODAL
  };
}

function getDetail(productId, orderNumber) {
  // console.log(productId);
  // console.log(orderNumber);
  return {
    types: [GETDETAIL, GETDETAIL_SUCCESS, GETDETAIL_FAIL],
    promise: function promise(client) {
      return client.post('/orderDetail', {
        data: {
          type: 'getDetail',
          productId: productId,
          orderNumber: orderNumber
        }
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/orderDetail.js
 ** module id = 629
 ** module chunks = 0
 **/